"use client"

import { analyticsEvent, analyticsEventData } from "../context/app-context"

const trackMapping: {
    [k in analyticsEvent]: string
} = {
    "remove_from_cart": "",
    "add_to_wishlist": "AddToWishlist",
    "add_to_cart": "AddToCart",
    "login": "",
    "sign_up": "Lead",
    "add_payment_info": "AddPaymentInfo",
    "purchase": "Purchase",
    "add_shipping_info": "",
    "refund": "",
    "view_item_list": "",
    "begin_checkout": "InitiateCheckout",
    "view_cart": "",
    "view_item": "ViewContent"
}


export const facebookAnalyticsEvent = (event: analyticsEvent, data: analyticsEventData) => {
    let trackData: any = {
        _originData: data
    };

    switch (event) {
        case "add_payment_info":
        case "add_to_cart":
        case "add_to_wishlist":
        case "begin_checkout":
        case "purchase":
        case "view_item":
            trackData.content_ids = data.items?.map(i => i.item_id)
            trackData.contents = data?.items?.map(i => ({
                ...i,
                id: i.item_id
            }))
            trackData.currency = data?.currency
            trackData.value = +(data?.value || 0)

            if (event === "add_to_cart") {
                trackData.content_type = "product"
            }

            if (["begin_checkout", "purchase"].includes(event)) {
                trackData.num_items = data.items?.reduce((a, b) => (+a || 0) + (+b || 0), 0)
            }
            break
    }

    //@ts-ignore
    window.fbq?.("track", trackMapping[event] || event, trackData)
}